import React from 'react';

import { Box, Typography, Tab, Tabs } from '@material-ui/core';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';

import { CustomAccordion } from '../../../../components/CustomAccordion';
import IKImage from '../../../../components/IKImage/IKImage';
import { LoadingOverlay } from '../../../../components/LoadingOverlay';
import { CardWrapper } from '../../../../components/UI/CardWrapper';
import { VideoListItem } from '../../../../components/VideoListItem';
import { User, Video } from '../../../../types';
import { secondsToHms } from '../../../../utils/helpers';
import TabPanel, { a11yProps } from '../../../AnalyticsPage/components/TabPanel/TabPanel';
import useStyles from './styles';

interface ExpertProps {
  expert?: User | null;
  videos: Video[];
  loadingVideos: boolean;
  isXApiPage?: boolean;
}

const Expert: React.FC<ExpertProps> = ({ expert, loadingVideos, videos, isXApiPage = false }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.wrapper} data-testid="expertSection">
      <Box className={classes.infoWrapper}>
        {expert?.avatar && (
          <IKImage
            className={classes.avatar}
            path={expert.avatar}
            alt={expert.name}
            srcset={[{ width: 92, height: 92, crop: 'maintain_ratio', focus: 'auto' }]}
            sizes="92px"
            draggable={false}
          />
        )}
        <Box className={classes.textInfo}>
          <Typography variant="h3" className={classes.name}>
            {expert?.name}
          </Typography>
          {expert?.description && (
            <Box className={classes.description}>{parse(expert.description)}</Box>
          )}
        </Box>
      </Box>
      <CardWrapper>
        <Tabs value={0}>
          <Tab
            classes={{
              root: classes.singleTabRoot,
            }}
            label={t('page.video.moreFrom', { expert: expert?.name })}
            {...a11yProps(0)}
          />
        </Tabs>
        <TabPanel value={0} index={0} className={classes.tabRoot}>
          {!loadingVideos && videos.length > 0 && (
            <div>
              <CustomAccordion
                itemsToShow={3}
                buttonClass={classes.viewBtn}
                wrapperClass={classes.accordionWrapper}
              >
                {videos.map((video) => (
                  <VideoListItem
                    key={video.id}
                    title={video.title}
                    imageUrl={video.preview_url}
                    url={isXApiPage ? undefined : video.url}
                    total={secondsToHms(video.duration)}
                    withPlayIcon
                    wrapperClass={classes.accordionItem}
                    data-testid="expertVideoItem"
                  />
                ))}
              </CustomAccordion>
            </div>
          )}
          {!loadingVideos && videos.length < 1 && (
            <Typography>{t('page.video.noVideosFrom', { expert: expert?.name })}</Typography>
          )}
          {loadingVideos && (
            <>
              <Typography>{t('common.loading')}...</Typography>
              <LoadingOverlay />
            </>
          )}
        </TabPanel>
      </CardWrapper>
    </Box>
  );
};

export default Expert;
